import React from "react";
import styled from "styled-components";
import { Loader } from "@vds/loaders";

export const FullPageLoaderWrapper = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  position: fixed;
  display: block;
`;


export default function FullPageLoader() {

    return (
        <FullPageLoaderWrapper data-testid="loader">
            <Loader  tabindex="-1" active />
        </FullPageLoaderWrapper>
    )
}